// extracted by mini-css-extract-plugin
export default {"container":"RiskMatrixResultModal_container__+GOjR","rowError":"RiskMatrixResultModal_rowError__CZ0wD","rowHit":"RiskMatrixResultModal_rowHit__Vae4E"};